import toast from 'react-hot-toast'

// Copy text for pasting elsewhere — a phone number or a message into WhatsApp.
//
// navigator.clipboard needs a secure context and a permission some kiosk browsers
// withhold, so an off-screen textarea + execCommand('copy') is the fallback: deprecated,
// but still the only path that works there. Every outcome ends in a toast — on a
// touchscreen POS there is no other feedback that the tap did anything.
export const copyText = async (text: string, successMessage: string): Promise<boolean> => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      toast.success(successMessage)
      return true
    }
  } catch {
    // Permission refused or API unavailable — fall through to the legacy path.
  }

  const area = document.createElement('textarea')
  area.value = text
  area.setAttribute('readonly', '')
  area.style.position = 'fixed'
  area.style.top = '-1000px'
  document.body.appendChild(area)
  area.select()
  let copied = false
  try {
    copied = document.execCommand('copy')
  } catch {
    copied = false
  }
  document.body.removeChild(area)

  if (copied) toast.success(successMessage)
  else toast.error('Could not copy. Please copy it by hand.')
  return copied
}
